import type { WorkflowEntityType } from '@pulse/shared';
import { useQuery } from '@tanstack/react-query';

import { fetchWorkflowDefinition } from '../api/workflow.api';

// `entityType` may be undefined while its own dependency (e.g. the project it belongs to)
// hasn't loaded yet — `enabled` keeps the query idle until a real value is available, letting
// callers use this hook unconditionally (rules-of-hooks) instead of guarding the call site.
export function useWorkflowDefinition(entityType: WorkflowEntityType | undefined) {
  return useQuery({
    queryKey: ['workflow-definitions', entityType],
    queryFn: () => fetchWorkflowDefinition(entityType as WorkflowEntityType),
    enabled: Boolean(entityType),
  });
}
